export default {
  app: {
    name: "AI Matching",
  },
};
